import { brandConfiguration } from "@/brands/config";
import { isLocalEnv } from "@/utils";
/*
 * Get route URLs based on brand configuration and environment.
 * In local environment, return all URL patterns from brand configuration. For local environment, base route is localhost and hence we need to set all URL patterns explicitly.
 * In non-local environment, base route is set by unified routing. Hence do not need to set them explicitly.
 * For Seloger brand, we need set additional URL patterns excluding baseRouteUrlPattern. Reason is difference in route patterns between seloger and other brands.
 */
export const getRouteUrls = () => {
    const { urlPatterns, baseRouteUrlPattern = "" } = brandConfiguration;
    const isLocal = isLocalEnv();
    if (isLocal) {
        return urlPatterns;
    }
    if (!baseRouteUrlPattern) {
        return ["/"];
    }
    const routesWithBaseRouteUrlPattern = urlPatterns.filter((pattern) => pattern.includes(baseRouteUrlPattern));
    const routeUrls = routesWithBaseRouteUrlPattern === null || routesWithBaseRouteUrlPattern === void 0 ? void 0 : routesWithBaseRouteUrlPattern.map((pattern) => `${pattern.replace(baseRouteUrlPattern, "")}/`);
    return [...routeUrls, "/"];
};
